import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(
    private _http: HttpClient
  ) { }

  public updateMediaUrl(mediaId:number, mediaUrl:string){
    if (mediaId && mediaUrl) {
      return this._http.put(environment.apiEndpoint + '/api/admin/mediaUrl', {mediaId:mediaId, mediaUrl:mediaUrl}).pipe(
        map(
          res => {
            return res;
          }
        )
      );
    }
  }

  public addMediaUrl(mediaUrl:string){
    return this._http.post(environment.apiEndpoint + '/api/admin/mediaUrl', {mediaUrl:mediaUrl}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getMediaUrl(mediaId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/mediaUrl/' + mediaId).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }
}
